/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Pit3_DInputs */

const en_to_typescript_pit3_d = /** @type {(inputs: To_Typescript_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inference cannot see fields your sample happened not to include, cannot know that a string field is really an enum of four values, and cannot know that a number is always an integer. If the API publishes an OpenAPI or JSON Schema document, generate from that instead. Use this tool when no schema exists.`)
};

const ko_to_typescript_pit3_d = /** @type {(inputs: To_Typescript_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추론은 샘플에 우연히 포함되지 않은 필드를 볼 수 없고, 문자열 필드가 실제로는 네 값의 열거형이라는 것도, 숫자가 항상 정수라는 것도 알 수 없습니다. API가 OpenAPI나 JSON Schema 문서를 공개한다면 그쪽에서 생성하세요. 스키마가 없을 때 이 도구를 쓰세요.`)
};

const ja_to_typescript_pit3_d = /** @type {(inputs: To_Typescript_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推論は、サンプルに偶然含まれなかったフィールドを見ることはできず、文字列フィールドが実は 4 値の列挙であることも、数値が常に整数であることも知りえません。API が OpenAPI や JSON Schema の文書を公開しているなら、そちらから生成してください。スキーマがないときにこのツールを使ってください。`)
};

/**
* | output |
* | --- |
* | "Inference cannot see fields your sample happened not to include, cannot know that a string field is really an enum of four values, and cannot know that a num..." |
*
* @param {To_Typescript_Pit3_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_pit3_d = /** @type {((inputs?: To_Typescript_Pit3_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Pit3_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_pit3_d(inputs)
	if (locale === "ko") return ko_to_typescript_pit3_d(inputs)
	return ja_to_typescript_pit3_d(inputs)
});